/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lucio API
 * Lucio AI Outlook Add-in Backend API
 * OpenAPI spec version: 1.0.0
 */
/**
 * ErrorResponse
 */
export interface ErrorResponse {
  details?: unknown;
  message: string;
  reason?: string;
  type?: string;
}

/**
 * ValidationErrorResponse
 */
export interface ValidationErrorResponse {
  errors: string[];
  message: string;
}

/**
 * DeviceExchangeResponse
 */
export type PostAuthDeviceExchange201 = {
  deviceToken: string;
};

export type PostAuthDeviceRefreshBody = {
  /**
   * Opaque device token issued by /auth/device/exchange
   * @minLength 1
   */
  deviceToken: string;
};

/**
 * DeviceRefreshResponse
 */
export type PostAuthDeviceRefresh200 = {
  accessToken: string;
  /** Id of the device session (sha256 of the device token, not a credential). Sent back as the `X-Lucio-Device-Session` header on every request with the access token. */
  deviceSessionId: string;
  expiresInSeconds: number;
};

export type PostAuthDeviceRevokeBody = {
  /**
   * Opaque device token issued by /auth/device/exchange
   * @minLength 1
   */
  deviceToken: string;
};

export type PostAuthDeviceRevoke200 = {
  ok: boolean;
};

export type PostAuthDeviceHandoffBodyAnyOf = {
  /**
   * Client-generated random handoff id, for the login dialog that still holds it. Proves the store belongs to this attempt.
   * @minLength 32
   * @maxLength 256
   */
  handoffId: string;
};

export type PostAuthDeviceHandoffBodyAnyOfTwo = {
  /**
   * Reference to the handoff id — lowercase hex sha256(handoffId) — carried by the login dialog through the auth round-trip. Not a credential: claiming needs the preimage.
   * @pattern ^[a-f0-9]{64}$
   */
  handoffRef: string;
};

export type PostAuthDeviceHandoffBody = PostAuthDeviceHandoffBodyAnyOf | PostAuthDeviceHandoffBodyAnyOfTwo;

export type PostAuthDeviceHandoff201 = {
  ok: boolean;
};

export type PostAuthDeviceHandoffClaimBody = {
  /**
   * Client-generated random handoff id. Held only by the taskpane and never sent anywhere else — presenting it is what authorises the claim.
   * @minLength 32
   * @maxLength 256
   */
  handoffId: string;
};

/**
 * DeviceExchangeResponse
 */
export type PostAuthDeviceHandoffClaim201 = {
  deviceToken: string;
};

export type GetAuthMe200UserAnyOfClerkId = string | null;

export type GetAuthMe200UserAnyOfDisplayName = string | null;

export type GetAuthMe200UserAnyOfInitialSyncCompletedAt = string | null;

export type GetAuthMe200UserAnyOfInitialSyncStartedAt = string | null;

export type GetAuthMe200UserAnyOfLocale = 'EN_GB' | 'EN_IN' | 'EN_US' | 'JA' | null;

export type GetAuthMe200UserAnyOfTimezone = string | null;

export type GetAuthMe200UserAnyOf = {
  aliases: string[];
  clerkId: GetAuthMe200UserAnyOfClerkId;
  displayName: GetAuthMe200UserAnyOfDisplayName;
  email: string;
  hasSeenNarrativeIntro: boolean;
  id: string;
  initialSyncCompletedAt: GetAuthMe200UserAnyOfInitialSyncCompletedAt;
  initialSyncStartedAt: GetAuthMe200UserAnyOfInitialSyncStartedAt;
  locale: GetAuthMe200UserAnyOfLocale;
  ragSearchEnabled: boolean;
  timezone: GetAuthMe200UserAnyOfTimezone;
};

export type GetAuthMe200User = GetAuthMe200UserAnyOf | null;

/**
 * MeResponse
 */
export type GetAuthMe200 = {
  /** False when the stored Graph credential is missing or revoked — reconnect needed */
  graphTokenActive: boolean;
  mailboxConnected: boolean;
  user: GetAuthMe200User;
};

export type PostAuthConnectMailboxBody = {
  /**
   * Microsoft identity token (audience api://<clientId>/access_as_user)
   * @minLength 1
   */
  identityToken: string;
  /** Switch mailboxes: unlink the caller’s previously connected mailbox before linking this one. Only displaces the caller’s own mailbox — cross-account conflicts still 409. */
  replaceExisting?: boolean;
};

export type PostAuthConnectMailbox200UserClerkId = string | null;

export type PostAuthConnectMailbox200UserDisplayName = string | null;

export type PostAuthConnectMailbox200UserInitialSyncCompletedAt = string | null;

export type PostAuthConnectMailbox200UserInitialSyncStartedAt = string | null;

export type PostAuthConnectMailbox200UserLocale = 'EN_GB' | 'EN_IN' | 'EN_US' | 'JA' | null;

export type PostAuthConnectMailbox200UserTimezone = string | null;

export type PostAuthConnectMailbox200User = {
  aliases: string[];
  clerkId: PostAuthConnectMailbox200UserClerkId;
  displayName: PostAuthConnectMailbox200UserDisplayName;
  email: string;
  hasSeenNarrativeIntro: boolean;
  id: string;
  initialSyncCompletedAt: PostAuthConnectMailbox200UserInitialSyncCompletedAt;
  initialSyncStartedAt: PostAuthConnectMailbox200UserInitialSyncStartedAt;
  locale: PostAuthConnectMailbox200UserLocale;
  ragSearchEnabled: boolean;
  timezone: PostAuthConnectMailbox200UserTimezone;
};

/**
 * ConnectMailboxResponse
 */
export type PostAuthConnectMailbox200 = {
  mailboxConnected: true;
  user: PostAuthConnectMailbox200User;
};

export type PostAuthConnectMailboxTicketBody = {
  /** Switch mailboxes: unlink the caller’s previously connected mailbox before linking. */
  replaceExisting?: boolean;
};

/**
 * ConnectMailboxTicketResponse
 */
export type PostAuthConnectMailboxTicket201 = {
  expiresInSeconds: number;
  ticket: string;
};

export type PostAuthConnectMailboxTicketStatusBody = {
  /**
   * Ticket issued by /auth/connect-mailbox-ticket
   * @minLength 1
   */
  ticket: string;
};

export type PostAuthConnectMailboxTicketStatus200Status = typeof PostAuthConnectMailboxTicketStatus200Status[keyof typeof PostAuthConnectMailboxTicketStatus200Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAuthConnectMailboxTicketStatus200Status = {
  pending: 'pending',
  linked: 'linked',
  conflict: 'conflict',
  denied: 'denied',
  failed: 'failed',
} as const;

/**
 * ConnectMailboxTicketStatusResponse
 */
export type PostAuthConnectMailboxTicketStatus200 = {
  /** User-appropriate failure summary */
  message?: string;
  /** Access-denial reason, when status is `denied` */
  reason?: string;
  status: PostAuthConnectMailboxTicketStatus200Status;
  /** Conflict type, when status is `conflict` */
  type?: string;
};

export type PostAuthConnectMailboxViaTicketBody = {
  /**
   * Microsoft identity token (audience api://<clientId>/access_as_user)
   * @minLength 1
   */
  identityToken: string;
  /**
   * Single-use ticket issued by /auth/connect-mailbox-ticket
   * @minLength 1
   */
  ticket: string;
};

export type PostAuthConnectMailboxViaTicket200UserClerkId = string | null;

export type PostAuthConnectMailboxViaTicket200UserDisplayName = string | null;

export type PostAuthConnectMailboxViaTicket200UserInitialSyncCompletedAt = string | null;

export type PostAuthConnectMailboxViaTicket200UserInitialSyncStartedAt = string | null;

export type PostAuthConnectMailboxViaTicket200UserLocale = 'EN_GB' | 'EN_IN' | 'EN_US' | 'JA' | null;

export type PostAuthConnectMailboxViaTicket200UserTimezone = string | null;

export type PostAuthConnectMailboxViaTicket200User = {
  aliases: string[];
  clerkId: PostAuthConnectMailboxViaTicket200UserClerkId;
  displayName: PostAuthConnectMailboxViaTicket200UserDisplayName;
  email: string;
  hasSeenNarrativeIntro: boolean;
  id: string;
  initialSyncCompletedAt: PostAuthConnectMailboxViaTicket200UserInitialSyncCompletedAt;
  initialSyncStartedAt: PostAuthConnectMailboxViaTicket200UserInitialSyncStartedAt;
  locale: PostAuthConnectMailboxViaTicket200UserLocale;
  ragSearchEnabled: boolean;
  timezone: PostAuthConnectMailboxViaTicket200UserTimezone;
};

/**
 * ConnectMailboxResponse
 */
export type PostAuthConnectMailboxViaTicket200 = {
  mailboxConnected: true;
  user: PostAuthConnectMailboxViaTicket200User;
};

export type PostAuthDisconnectMailbox200 = {
  message: string;
};

export type GetUserAssistantPreferences200AssistantPreferencesAnyOf = {
  draftingPreferences: string;
  generalInfo: string;
};

export type GetUserAssistantPreferences200AssistantPreferences = GetUserAssistantPreferences200AssistantPreferencesAnyOf | null;

export type GetUserAssistantPreferences200NarrativePreferencesAnyOf = {
  narrativeStyle: string;
  sampleNarratives: string[];
};

export type GetUserAssistantPreferences200NarrativePreferences = GetUserAssistantPreferences200NarrativePreferencesAnyOf | null;

export type GetUserAssistantPreferences200 = {
  assistantPreferences: GetUserAssistantPreferences200AssistantPreferences;
  narrativePreferences: GetUserAssistantPreferences200NarrativePreferences;
  preferencesEnabled: boolean;
};

export type PostUserAssistantPreferencesBody = {
  enableMemory?: boolean;
};

export type PostUserAssistantPreferences200AssistantPreferencesAnyOf = {
  draftingPreferences: string;
  generalInfo: string;
};

export type PostUserAssistantPreferences200AssistantPreferences = PostUserAssistantPreferences200AssistantPreferencesAnyOf | null;

export type PostUserAssistantPreferences200DisplayName = string | null;

export type PostUserAssistantPreferences200 = {
  assistantPreferences?: PostUserAssistantPreferences200AssistantPreferences;
  displayName: PostUserAssistantPreferences200DisplayName;
  email: string;
  id: string;
  preferencesEnabled: boolean;
};

export type GetUserInitialSyncStatus200 = {
  completed: boolean;
};

export type GetUserIntercom200 = {
  token: string;
};

export type PostUserNarrativePreferencesBody = {
  narrativeStyle?: string;
  sampleNarratives?: string[];
};

export type PostUserNarrativePreferences200NarrativePreferencesAnyOf = {
  narrativeStyle: string;
  sampleNarratives: string[];
};

export type PostUserNarrativePreferences200NarrativePreferences = PostUserNarrativePreferences200NarrativePreferencesAnyOf | null;

export type PostUserNarrativePreferences200NarrativeStyleUpdatedAt = string | null;

export type PostUserNarrativePreferences200 = {
  id: string;
  narrativePreferences?: PostUserNarrativePreferences200NarrativePreferences;
  narrativeStyleUpdatedAt?: PostUserNarrativePreferences200NarrativeStyleUpdatedAt;
};

export type PutUserAssistantPreferencesProfileBody = {
  /** @minLength 1 */
  draftingPreferences: string;
  /** @minLength 1 */
  generalInfo: string;
};

export type PutUserAssistantPreferencesProfile200AssistantPreferencesAnyOf = {
  draftingPreferences: string;
  generalInfo: string;
};

export type PutUserAssistantPreferencesProfile200AssistantPreferences = PutUserAssistantPreferencesProfile200AssistantPreferencesAnyOf | null;

export type PutUserAssistantPreferencesProfile200 = {
  assistantPreferences: PutUserAssistantPreferencesProfile200AssistantPreferences;
  id: string;
};

export type PostUserGenerateProfileBody = { [key: string]: unknown };

export type PostUserGenerateProfile200AnyOfAssistantPreferencesAnyOf = {
  draftingPreferences: string;
  generalInfo: string;
};

export type PostUserGenerateProfile200AnyOfAssistantPreferences = PostUserGenerateProfile200AnyOfAssistantPreferencesAnyOf | null;

export type PostUserGenerateProfile200AnyOf = {
  assistantPreferences?: PostUserGenerateProfile200AnyOfAssistantPreferences;
  id: string;
};

export type PostUserGenerateProfile200 = PostUserGenerateProfile200AnyOf | null;

export type PutUserLocaleBody = {
  locale: string;
};

export type PutUserLocale200Locale = 'EN_GB' | 'EN_IN' | 'EN_US' | 'JA' | null;

export type PutUserLocale200 = {
  id: string;
  locale: PutUserLocale200Locale;
};

export type PutUserTimezoneBody = {
  timezone: string;
};

export type PutUserTimezone200Timezone = string | null;

export type PutUserTimezone200 = {
  id: string;
  timezone: PutUserTimezone200Timezone;
};

export type PutUserDisplayNameBody = {
  /**
   * @minLength 1
   * @maxLength 120
   */
  displayName: string;
};

export type PutUserDisplayName200DisplayName = string | null;

export type PutUserDisplayName200 = {
  displayName: PutUserDisplayName200DisplayName;
  id: string;
};

export type PostInboxFetchBody = {
  contextEmailIds?: string[];
  limit?: number;
  search?: string;
  skip?: number;
};

export type PostInboxFetch200ValueItemFrom = {
  email: string;
  name: string;
};

export type PostInboxFetch200ValueItem = {
  bodyPreview?: string;
  from?: PostInboxFetch200ValueItemFrom;
  id: string;
  isRead?: boolean;
  receivedDateTime?: string;
  subject?: string;
  webLink?: string;
};

export type PostInboxFetch200 = {
  '@odata.context'?: string;
  '@odata.nextLink'?: string;
  value: PostInboxFetch200ValueItem[];
};

export type PostInboxContextEmailsBody = {
  /** @minItems 1 */
  contextEmailIds: string[];
};

export type PostInboxContextEmails200ItemFrom = {
  email: string;
  name: string;
};

export type PostInboxContextEmails200Item = {
  bodyPreview?: string;
  from?: PostInboxContextEmails200ItemFrom;
  id: string;
  isRead?: boolean;
  receivedDateTime?: string;
  subject?: string;
  webLink?: string;
};

export type PostAssistantChatBodyContext = typeof PostAssistantChatBodyContext[keyof typeof PostAssistantChatBodyContext];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAssistantChatBodyContext = {
  INBOX: 'INBOX',
  THREAD: 'THREAD',
  EMAIL: 'EMAIL',
  CUSTOM: 'CUSTOM',
  FOLDER: 'FOLDER',
} as const;

export type PostAssistantChatBody = {
  attachments?: string[];
  composeBody?: string;
  context: PostAssistantChatBodyContext;
  currentEmailId?: string;
  currentThreadId?: string;
  customEmailIds?: string[];
  draftId?: string;
  folderId?: string;
  folderName?: string;
  /** @minLength 1 */
  prompt: string;
  /** @pattern ^[0-9a-fA-F]{24}$ */
  sessionId?: string;
};

export type PostAssistantEnhancePromptBody = {
  /**
   * @minLength 1
   * @maxLength 500
   */
  prompt: string;
};

export type PostAssistantEnhancePrompt200 = {
  enhanced: string;
  original: string;
  variables?: string[];
};

export type GetAssistantFolders200FoldersItem = {
  id: string;
  name: string;
};

export type GetAssistantFolders200 = {
  folders: GetAssistantFolders200FoldersItem[];
};

export type GetAssistantSessionsParams = {
/**
 * @maximum 9007199254740991
 */
limit?: number;
/**
 * @maximum 9007199254740991
 */
page?: number;
search?: string;
};

export type GetAssistantSessions200Pagination = {
  limit: number;
  page: number;
  total: number;
  totalPages: number;
};

export type GetAssistantSessions200SessionsItemCompletedAt = string | null;

export type GetAssistantSessions200SessionsItemContext = typeof GetAssistantSessions200SessionsItemContext[keyof typeof GetAssistantSessions200SessionsItemContext];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssistantSessions200SessionsItemContext = {
  INBOX: 'INBOX',
  THREAD: 'THREAD',
  EMAIL: 'EMAIL',
  CUSTOM: 'CUSTOM',
  FOLDER: 'FOLDER',
} as const;

export type GetAssistantSessions200SessionsItemConversationId = string | null;

export type GetAssistantSessions200SessionsItemDraftId = string | null;

export type GetAssistantSessions200SessionsItemEmailId = string | null;

export type GetAssistantSessions200SessionsItemFolderId = string | null;

export type GetAssistantSessions200SessionsItemFolderName = string | null;

export type GetAssistantSessions200SessionsItemMode = typeof GetAssistantSessions200SessionsItemMode[keyof typeof GetAssistantSessions200SessionsItemMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssistantSessions200SessionsItemMode = {
  ASK: 'ASK',
  DRAFT: 'DRAFT',
  EDIT: 'EDIT',
} as const;

export type GetAssistantSessions200SessionsItemTitle = string | null;

export type GetAssistantSessions200SessionsItem = {
  completedAt?: GetAssistantSessions200SessionsItemCompletedAt;
  context: GetAssistantSessions200SessionsItemContext;
  contextEmailIds?: string[];
  conversationId?: GetAssistantSessions200SessionsItemConversationId;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  draftId?: GetAssistantSessions200SessionsItemDraftId;
  emailId?: GetAssistantSessions200SessionsItemEmailId;
  folderId?: GetAssistantSessions200SessionsItemFolderId;
  folderName?: GetAssistantSessions200SessionsItemFolderName;
  id: string;
  mode: GetAssistantSessions200SessionsItemMode;
  title?: GetAssistantSessions200SessionsItemTitle;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
};

export type GetAssistantSessions200 = {
  pagination: GetAssistantSessions200Pagination;
  sessions: GetAssistantSessions200SessionsItem[];
};

export type GetAssistantSessionsContextParams = {
conversationId?: string;
draftId?: string;
emailId?: string;
};

export type GetAssistantSessionsContext200AnyOf = {
  sessionId: string;
};

export type GetAssistantSessionsContext200 = GetAssistantSessionsContext200AnyOf | null;

export type GetAssistantSessionsBySessionIdMessagesParams = {
/**
 * @minLength 1
 */
cursor?: string;
/**
 * @maximum 9007199254740991
 */
limit?: number;
};

export type GetAssistantSessionsBySessionIdMessages200CompletedAt = string | null;

export type GetAssistantSessionsBySessionIdMessages200Context = typeof GetAssistantSessionsBySessionIdMessages200Context[keyof typeof GetAssistantSessionsBySessionIdMessages200Context];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssistantSessionsBySessionIdMessages200Context = {
  INBOX: 'INBOX',
  THREAD: 'THREAD',
  EMAIL: 'EMAIL',
  CUSTOM: 'CUSTOM',
  FOLDER: 'FOLDER',
} as const;

export type GetAssistantSessionsBySessionIdMessages200ConversationId = string | null;

export type GetAssistantSessionsBySessionIdMessages200DraftId = string | null;

export type GetAssistantSessionsBySessionIdMessages200EmailId = string | null;

export type GetAssistantSessionsBySessionIdMessages200FolderId = string | null;

export type GetAssistantSessionsBySessionIdMessages200FolderName = string | null;

export type GetAssistantSessionsBySessionIdMessages200Mode = typeof GetAssistantSessionsBySessionIdMessages200Mode[keyof typeof GetAssistantSessionsBySessionIdMessages200Mode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssistantSessionsBySessionIdMessages200Mode = {
  ASK: 'ASK',
  DRAFT: 'DRAFT',
  EDIT: 'EDIT',
} as const;

export type GetAssistantSessionsBySessionIdMessages200Title = string | null;

export type GetAssistantSessionsBySessionIdMessages200AttachmentsItem = {
  fileName: string;
  fileSize: number;
  id: string;
  mimeType: string;
  url: string;
};

export type GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfFrom = {
  email: string;
  name: string;
};

export type GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOf = {
  from: GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfFrom;
  kind: 'email';
  messageId: string;
  receivedAt: string;
  subject: string;
  summary: string;
  webLink?: string;
};

export type GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThreeParentEmailFrom = {
  email: string;
  name: string;
};

export type GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThreeParentEmail = {
  from: GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThreeParentEmailFrom;
  messageId: string;
  subject: string;
};

export type GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThreeSourceType = typeof GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThreeSourceType[keyof typeof GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThreeSourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThreeSourceType = {
  CHAT_UPLOAD: 'CHAT_UPLOAD',
  EMAIL: 'EMAIL',
} as const;

export type GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThree = {
  attachmentId: string;
  emailAttachmentId?: string;
  fileName: string;
  kind: 'attachment';
  mimeType: string;
  page?: number;
  parentEmail?: GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThreeParentEmail;
  quote?: string;
  sourceType: GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThreeSourceType;
};

export type GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOf = {[key: string]: GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOf | GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOfOneOfThree};

export type GetAssistantSessionsBySessionIdMessages200MessagesItemCitations = GetAssistantSessionsBySessionIdMessages200MessagesItemCitationsAnyOf | null;

export type GetAssistantSessionsBySessionIdMessages200MessagesItemContentType = string | null;

export type GetAssistantSessionsBySessionIdMessages200MessagesItemOriginalContent = string | null;

export type GetAssistantSessionsBySessionIdMessages200MessagesItemRole = typeof GetAssistantSessionsBySessionIdMessages200MessagesItemRole[keyof typeof GetAssistantSessionsBySessionIdMessages200MessagesItemRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssistantSessionsBySessionIdMessages200MessagesItemRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;

export type GetAssistantSessionsBySessionIdMessages200MessagesItem = {
  attachmentIds?: string[];
  citations?: GetAssistantSessionsBySessionIdMessages200MessagesItemCitations;
  content: string;
  contentType?: GetAssistantSessionsBySessionIdMessages200MessagesItemContentType;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  id: string;
  originalContent?: GetAssistantSessionsBySessionIdMessages200MessagesItemOriginalContent;
  role: GetAssistantSessionsBySessionIdMessages200MessagesItemRole;
  sessionV2Id: string;
  streamed?: boolean;
};

export type GetAssistantSessionsBySessionIdMessages200NextCursor = string | null;

export type GetAssistantSessionsBySessionIdMessages200 = {
  completedAt?: GetAssistantSessionsBySessionIdMessages200CompletedAt;
  context: GetAssistantSessionsBySessionIdMessages200Context;
  contextEmailIds?: string[];
  conversationId?: GetAssistantSessionsBySessionIdMessages200ConversationId;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  draftId?: GetAssistantSessionsBySessionIdMessages200DraftId;
  emailId?: GetAssistantSessionsBySessionIdMessages200EmailId;
  folderId?: GetAssistantSessionsBySessionIdMessages200FolderId;
  folderName?: GetAssistantSessionsBySessionIdMessages200FolderName;
  id: string;
  mode: GetAssistantSessionsBySessionIdMessages200Mode;
  title?: GetAssistantSessionsBySessionIdMessages200Title;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
  attachments: GetAssistantSessionsBySessionIdMessages200AttachmentsItem[];
  hasMore: boolean;
  messages: GetAssistantSessionsBySessionIdMessages200MessagesItem[];
  nextCursor?: GetAssistantSessionsBySessionIdMessages200NextCursor;
};

export type DeleteAssistantSessionsBySessionId200 = {
  message: string;
};

/**
 * Attachment purpose
 */
export type PostAttachmentsUploadBodyPurpose = typeof PostAttachmentsUploadBodyPurpose[keyof typeof PostAttachmentsUploadBodyPurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAttachmentsUploadBodyPurpose = {
  SESSION: 'SESSION',
  NARRATIVE: 'NARRATIVE',
} as const;

export type PostAttachmentsUploadBody = {
  /** File to upload */
  file: Blob;
  /** Attachment purpose */
  purpose?: PostAttachmentsUploadBodyPurpose;
};

export type PostAttachmentsUpload200Purpose = typeof PostAttachmentsUpload200Purpose[keyof typeof PostAttachmentsUpload200Purpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAttachmentsUpload200Purpose = {
  SESSION: 'SESSION',
  NARRATIVE: 'NARRATIVE',
} as const;

export type PostAttachmentsUpload200 = {
  fileName: string;
  fileSize: number;
  id: string;
  mimeType: string;
  purpose: PostAttachmentsUpload200Purpose;
};

/**
 * Attachment purpose
 */
export type PostAttachmentsBulkUploadBodyPurpose = typeof PostAttachmentsBulkUploadBodyPurpose[keyof typeof PostAttachmentsBulkUploadBodyPurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAttachmentsBulkUploadBodyPurpose = {
  SESSION: 'SESSION',
  NARRATIVE: 'NARRATIVE',
} as const;

export type PostAttachmentsBulkUploadBody = {
  /** Files to upload */
  files: Blob[];
  /** Attachment purpose */
  purpose?: PostAttachmentsBulkUploadBodyPurpose;
};

export type PostAttachmentsBulkUpload200ItemPurpose = typeof PostAttachmentsBulkUpload200ItemPurpose[keyof typeof PostAttachmentsBulkUpload200ItemPurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAttachmentsBulkUpload200ItemPurpose = {
  SESSION: 'SESSION',
  NARRATIVE: 'NARRATIVE',
} as const;

export type PostAttachmentsBulkUpload200Item = {
  fileName: string;
  fileSize: number;
  id: string;
  mimeType: string;
  purpose: PostAttachmentsBulkUpload200ItemPurpose;
};

export type GetAttachmentsListParams = {
purpose: GetAttachmentsListPurpose;
};

export type GetAttachmentsListPurpose = typeof GetAttachmentsListPurpose[keyof typeof GetAttachmentsListPurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAttachmentsListPurpose = {
  SESSION: 'SESSION',
  NARRATIVE: 'NARRATIVE',
} as const;

export type GetAttachmentsList200ItemPurpose = typeof GetAttachmentsList200ItemPurpose[keyof typeof GetAttachmentsList200ItemPurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAttachmentsList200ItemPurpose = {
  SESSION: 'SESSION',
  NARRATIVE: 'NARRATIVE',
} as const;

export type GetAttachmentsList200Item = {
  fileName: string;
  fileSize: number;
  id: string;
  mimeType: string;
  purpose: GetAttachmentsList200ItemPurpose;
};

export type DeleteAttachmentsBulkDeleteBody = {
  /**
   * Array of attachment IDs to delete
   * @minItems 1
   */
  ids: string[];
};

export type DeleteAttachmentsBulkDelete200 = {
  message: string;
};

export type GetAttachmentsByIdAccessUrlParams = {
disposition: GetAttachmentsByIdAccessUrlDisposition;
};

export type GetAttachmentsByIdAccessUrlDisposition = typeof GetAttachmentsByIdAccessUrlDisposition[keyof typeof GetAttachmentsByIdAccessUrlDisposition];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAttachmentsByIdAccessUrlDisposition = {
  inline: 'inline',
  attachment: 'attachment',
} as const;

export type GetAttachmentsByIdAccessUrl200 = {
  /** ISO 8601 SAS expiry */
  expiresAt: string;
  /** Short-lived Azure SAS URL */
  url: string;
};

export type GetAttachmentsEmailByGraphMessageIdByGraphAttachmentIdStreamParams = {
disposition?: GetAttachmentsEmailByGraphMessageIdByGraphAttachmentIdStreamDisposition;
};

export type GetAttachmentsEmailByGraphMessageIdByGraphAttachmentIdStreamDisposition = typeof GetAttachmentsEmailByGraphMessageIdByGraphAttachmentIdStreamDisposition[keyof typeof GetAttachmentsEmailByGraphMessageIdByGraphAttachmentIdStreamDisposition];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAttachmentsEmailByGraphMessageIdByGraphAttachmentIdStreamDisposition = {
  inline: 'inline',
  attachment: 'attachment',
} as const;

export type DeleteAttachmentsById200 = {
  message: string;
};

export type PostTranscriptionTranscribeBody = {
  /** Audio file (max 5MB) */
  audio: Blob;
  /** Locale for transcription (e.g. en, ja-JP) */
  language?: string;
};

export type PostTranscriptionTranscribe200Duration = number | null;

export type PostTranscriptionTranscribe200 = {
  duration: PostTranscriptionTranscribe200Duration;
  language: string;
  transcript: string;
};

export type GetNarrativeParams = {
jobId?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 1
 * @maximum 9007199254740991
 */
page?: number;
type: GetNarrativeType;
};

export type GetNarrativeType = typeof GetNarrativeType[keyof typeof GetNarrativeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNarrativeType = {
  TODAY: 'TODAY',
  WEEK: 'WEEK',
  CUSTOM: 'CUSTOM',
} as const;

export type GetNarrative200NarrativesItemConversationId = string | null;

export type GetNarrative200NarrativesItemFromName = string | null;

export type GetNarrative200NarrativesItemJobId = string | null;

export type GetNarrative200NarrativesItem = {
  conversationId?: GetNarrative200NarrativesItemConversationId;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  emailSubject: string;
  fromName?: GetNarrative200NarrativesItemFromName;
  graphMessageId: string;
  hasAttachments: boolean;
  id: string;
  jobId?: GetNarrative200NarrativesItemJobId;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  sentAt: string;
  summary: string;
  suppressed: boolean;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
  userId: string;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  workDate: string;
};

export type GetNarrative200Pagination = {
  limit: number;
  page: number;
  total: number;
  totalPages: number;
};

export type GetNarrative200 = {
  narratives: GetNarrative200NarrativesItem[];
  pagination: GetNarrative200Pagination;
};

export type GetNarrativeWalkthrough200 = {
  hasSeenNarrativeIntro: boolean;
  walkThroughStep: number;
};

export type PatchNarrativeWalkthroughStepBody = {
  /**
   * @minimum 1
   * @maximum 3
   */
  step: number;
};

export type PatchNarrativeWalkthroughStep200 = {
  hasSeenNarrativeIntro: boolean;
  walkThroughStep: number;
};

export type PostNarrativeTriggerBodyType = typeof PostNarrativeTriggerBodyType[keyof typeof PostNarrativeTriggerBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostNarrativeTriggerBodyType = {
  TODAY: 'TODAY',
  WEEK: 'WEEK',
  CUSTOM: 'CUSTOM',
} as const;

export type PostNarrativeTriggerBody = {
  /** @pattern ^\d{4}-\d{2}-\d{2}$ */
  endDate?: string;
  /** @pattern ^\d{4}-\d{2}-\d{2}$ */
  startDate?: string;
  type: PostNarrativeTriggerBodyType;
};

export type PostNarrativeTrigger200EndDate = string | null;

export type PostNarrativeTrigger200StartDate = string | null;

export type PostNarrativeTrigger200Status = typeof PostNarrativeTrigger200Status[keyof typeof PostNarrativeTrigger200Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostNarrativeTrigger200Status = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export type PostNarrativeTrigger200Style = string | null;

export type PostNarrativeTrigger200Type = typeof PostNarrativeTrigger200Type[keyof typeof PostNarrativeTrigger200Type];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostNarrativeTrigger200Type = {
  TODAY: 'TODAY',
  WEEK: 'WEEK',
  CUSTOM: 'CUSTOM',
} as const;

export type PostNarrativeTrigger200 = {
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  endDate?: PostNarrativeTrigger200EndDate;
  id: string;
  startDate?: PostNarrativeTrigger200StartDate;
  status: PostNarrativeTrigger200Status;
  style?: PostNarrativeTrigger200Style;
  type: PostNarrativeTrigger200Type;
  userId: string;
};

export type GetNarrativeJobs200ItemEndDate = string | null;

export type GetNarrativeJobs200ItemStartDate = string | null;

export type GetNarrativeJobs200ItemStatus = typeof GetNarrativeJobs200ItemStatus[keyof typeof GetNarrativeJobs200ItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNarrativeJobs200ItemStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export type GetNarrativeJobs200ItemStyle = string | null;

export type GetNarrativeJobs200ItemType = typeof GetNarrativeJobs200ItemType[keyof typeof GetNarrativeJobs200ItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNarrativeJobs200ItemType = {
  TODAY: 'TODAY',
  WEEK: 'WEEK',
  CUSTOM: 'CUSTOM',
} as const;

export type GetNarrativeJobs200Item = {
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  endDate?: GetNarrativeJobs200ItemEndDate;
  id: string;
  startDate?: GetNarrativeJobs200ItemStartDate;
  status: GetNarrativeJobs200ItemStatus;
  style?: GetNarrativeJobs200ItemStyle;
  type: GetNarrativeJobs200ItemType;
  userId: string;
  count: number;
};

export type PatchNarrativeByIdBody = {
  /** @minLength 1 */
  summary?: string;
  suppressed?: boolean;
};

export type PatchNarrativeById200ConversationId = string | null;

export type PatchNarrativeById200FromName = string | null;

export type PatchNarrativeById200JobId = string | null;

export type PatchNarrativeById200 = {
  conversationId?: PatchNarrativeById200ConversationId;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  emailSubject: string;
  fromName?: PatchNarrativeById200FromName;
  graphMessageId: string;
  hasAttachments: boolean;
  id: string;
  jobId?: PatchNarrativeById200JobId;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  sentAt: string;
  summary: string;
  suppressed: boolean;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
  userId: string;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  workDate: string;
};

export type DeleteNarrativeById200 = {
  message: string;
};

export type PostAssistantSuggestionsBodyScope = typeof PostAssistantSuggestionsBodyScope[keyof typeof PostAssistantSuggestionsBodyScope];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAssistantSuggestionsBodyScope = {
  EMAIL: 'EMAIL',
  THREAD: 'THREAD',
  INBOX: 'INBOX',
} as const;

export type PostAssistantSuggestionsBody = {
  conversationId?: string;
  messageId?: string;
  scope: PostAssistantSuggestionsBodyScope;
};

export type PostAssistantSuggestions200 = {
  data: string[];
};

export type GetAutomations200ItemCron = string | null;

export type GetAutomations200ItemCronSchedule = string | null;

export type GetAutomations200ItemName = string | null;

export type GetAutomations200ItemNextRun = string | null;

export type GetAutomations200ItemStartTrigger = typeof GetAutomations200ItemStartTrigger[keyof typeof GetAutomations200ItemStartTrigger];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAutomations200ItemStartTrigger = {
  NEW_MAIL: 'NEW_MAIL',
  CRON: 'CRON',
  MANUAL: 'MANUAL',
} as const;

export type GetAutomations200Item = {
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  cron?: GetAutomations200ItemCron;
  cronSchedule?: GetAutomations200ItemCronSchedule;
  id: string;
  isEnabled: boolean;
  name?: GetAutomations200ItemName;
  nextRun?: GetAutomations200ItemNextRun;
  prompt: string;
  startTrigger: GetAutomations200ItemStartTrigger;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
  userId: string;
};

export type PostAutomationsBodyStartTrigger = typeof PostAutomationsBodyStartTrigger[keyof typeof PostAutomationsBodyStartTrigger];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAutomationsBodyStartTrigger = {
  NEW_MAIL: 'NEW_MAIL',
  CRON: 'CRON',
  MANUAL: 'MANUAL',
} as const;

export type PostAutomationsBody = {
  /** Human-readable schedule description, e.g. "every day at 5 PM" */
  cronSchedule?: string;
  isEnabled?: boolean;
  /**
   * Optional explicit name; falls back to an agent-generated title when omitted
   * @minLength 1
   */
  name?: string;
  /** @minLength 1 */
  prompt: string;
  startTrigger: PostAutomationsBodyStartTrigger;
};

export type PostAutomations200Cron = string | null;

export type PostAutomations200CronSchedule = string | null;

export type PostAutomations200Name = string | null;

export type PostAutomations200NextRun = string | null;

export type PostAutomations200StartTrigger = typeof PostAutomations200StartTrigger[keyof typeof PostAutomations200StartTrigger];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAutomations200StartTrigger = {
  NEW_MAIL: 'NEW_MAIL',
  CRON: 'CRON',
  MANUAL: 'MANUAL',
} as const;

export type PostAutomations200 = {
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  cron?: PostAutomations200Cron;
  cronSchedule?: PostAutomations200CronSchedule;
  id: string;
  isEnabled: boolean;
  name?: PostAutomations200Name;
  nextRun?: PostAutomations200NextRun;
  prompt: string;
  startTrigger: PostAutomations200StartTrigger;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
  userId: string;
};

export type GetAutomationsById200Cron = string | null;

export type GetAutomationsById200CronSchedule = string | null;

export type GetAutomationsById200Name = string | null;

export type GetAutomationsById200NextRun = string | null;

export type GetAutomationsById200StartTrigger = typeof GetAutomationsById200StartTrigger[keyof typeof GetAutomationsById200StartTrigger];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAutomationsById200StartTrigger = {
  NEW_MAIL: 'NEW_MAIL',
  CRON: 'CRON',
  MANUAL: 'MANUAL',
} as const;

export type GetAutomationsById200 = {
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  cron?: GetAutomationsById200Cron;
  cronSchedule?: GetAutomationsById200CronSchedule;
  id: string;
  isEnabled: boolean;
  name?: GetAutomationsById200Name;
  nextRun?: GetAutomationsById200NextRun;
  prompt: string;
  startTrigger: GetAutomationsById200StartTrigger;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
  userId: string;
};

export type PatchAutomationsByIdBodyCronSchedule = string | null;

export type PatchAutomationsByIdBodyStartTrigger = typeof PatchAutomationsByIdBodyStartTrigger[keyof typeof PatchAutomationsByIdBodyStartTrigger];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchAutomationsByIdBodyStartTrigger = {
  NEW_MAIL: 'NEW_MAIL',
  CRON: 'CRON',
  MANUAL: 'MANUAL',
} as const;

export type PatchAutomationsByIdBody = {
  cronSchedule?: PatchAutomationsByIdBodyCronSchedule;
  isEnabled?: boolean;
  /** @minLength 1 */
  prompt?: string;
  startTrigger?: PatchAutomationsByIdBodyStartTrigger;
};

export type PatchAutomationsById200Cron = string | null;

export type PatchAutomationsById200CronSchedule = string | null;

export type PatchAutomationsById200Name = string | null;

export type PatchAutomationsById200NextRun = string | null;

export type PatchAutomationsById200StartTrigger = typeof PatchAutomationsById200StartTrigger[keyof typeof PatchAutomationsById200StartTrigger];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchAutomationsById200StartTrigger = {
  NEW_MAIL: 'NEW_MAIL',
  CRON: 'CRON',
  MANUAL: 'MANUAL',
} as const;

export type PatchAutomationsById200 = {
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  cron?: PatchAutomationsById200Cron;
  cronSchedule?: PatchAutomationsById200CronSchedule;
  id: string;
  isEnabled: boolean;
  name?: PatchAutomationsById200Name;
  nextRun?: PatchAutomationsById200NextRun;
  prompt: string;
  startTrigger: PatchAutomationsById200StartTrigger;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
  userId: string;
};

export type DeleteAutomationsById200 = {
  message: string;
};

export type PostAutomationsByIdRun200 = {
  runId: string;
};

export type GetAutomationsByIdRuns200ItemActionsTakenAnyOf = {
  completed: string[];
  failed: string[];
  skipped: string[];
};

export type GetAutomationsByIdRuns200ItemActionsTaken = GetAutomationsByIdRuns200ItemActionsTakenAnyOf | null;

export type GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfFrom = {
  email: string;
  name: string;
};

export type GetAutomationsByIdRuns200ItemCitationsAnyOfOneOf = {
  from: GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfFrom;
  kind: 'email';
  messageId: string;
  receivedAt: string;
  subject: string;
  summary: string;
  webLink?: string;
};

export type GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThreeParentEmailFrom = {
  email: string;
  name: string;
};

export type GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThreeParentEmail = {
  from: GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThreeParentEmailFrom;
  messageId: string;
  subject: string;
};

export type GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThreeSourceType = typeof GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThreeSourceType[keyof typeof GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThreeSourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThreeSourceType = {
  CHAT_UPLOAD: 'CHAT_UPLOAD',
  EMAIL: 'EMAIL',
} as const;

export type GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThree = {
  attachmentId: string;
  emailAttachmentId?: string;
  fileName: string;
  kind: 'attachment';
  mimeType: string;
  page?: number;
  parentEmail?: GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThreeParentEmail;
  quote?: string;
  sourceType: GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThreeSourceType;
};

export type GetAutomationsByIdRuns200ItemCitationsAnyOf = {[key: string]: GetAutomationsByIdRuns200ItemCitationsAnyOfOneOf | GetAutomationsByIdRuns200ItemCitationsAnyOfOneOfThree};

export type GetAutomationsByIdRuns200ItemCitations = GetAutomationsByIdRuns200ItemCitationsAnyOf | null;

export type GetAutomationsByIdRuns200ItemOutput = string | null;

export type GetAutomationsByIdRuns200ItemStatus = typeof GetAutomationsByIdRuns200ItemStatus[keyof typeof GetAutomationsByIdRuns200ItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAutomationsByIdRuns200ItemStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export type GetAutomationsByIdRuns200Item = {
  actionsTaken?: GetAutomationsByIdRuns200ItemActionsTaken;
  automationId: string;
  citations?: GetAutomationsByIdRuns200ItemCitations;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  id: string;
  output?: GetAutomationsByIdRuns200ItemOutput;
  status: GetAutomationsByIdRuns200ItemStatus;
};

export type GetAutomationsByIdRunsByRunId200ActionsTakenAnyOf = {
  completed: string[];
  failed: string[];
  skipped: string[];
};

export type GetAutomationsByIdRunsByRunId200ActionsTaken = GetAutomationsByIdRunsByRunId200ActionsTakenAnyOf | null;

export type GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfFrom = {
  email: string;
  name: string;
};

export type GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOf = {
  from: GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfFrom;
  kind: 'email';
  messageId: string;
  receivedAt: string;
  subject: string;
  summary: string;
  webLink?: string;
};

export type GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThreeParentEmailFrom = {
  email: string;
  name: string;
};

export type GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThreeParentEmail = {
  from: GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThreeParentEmailFrom;
  messageId: string;
  subject: string;
};

export type GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThreeSourceType = typeof GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThreeSourceType[keyof typeof GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThreeSourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThreeSourceType = {
  CHAT_UPLOAD: 'CHAT_UPLOAD',
  EMAIL: 'EMAIL',
} as const;

export type GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThree = {
  attachmentId: string;
  emailAttachmentId?: string;
  fileName: string;
  kind: 'attachment';
  mimeType: string;
  page?: number;
  parentEmail?: GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThreeParentEmail;
  quote?: string;
  sourceType: GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThreeSourceType;
};

export type GetAutomationsByIdRunsByRunId200CitationsAnyOf = {[key: string]: GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOf | GetAutomationsByIdRunsByRunId200CitationsAnyOfOneOfThree};

export type GetAutomationsByIdRunsByRunId200Citations = GetAutomationsByIdRunsByRunId200CitationsAnyOf | null;

export type GetAutomationsByIdRunsByRunId200Output = string | null;

export type GetAutomationsByIdRunsByRunId200Status = typeof GetAutomationsByIdRunsByRunId200Status[keyof typeof GetAutomationsByIdRunsByRunId200Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAutomationsByIdRunsByRunId200Status = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export type GetAutomationsByIdRunsByRunId200 = {
  actionsTaken?: GetAutomationsByIdRunsByRunId200ActionsTaken;
  automationId: string;
  citations?: GetAutomationsByIdRunsByRunId200Citations;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  id: string;
  output?: GetAutomationsByIdRunsByRunId200Output;
  status: GetAutomationsByIdRunsByRunId200Status;
};

export type GetActionsParams = {
/**
 * Action ID to start after (returned as nextCursor in the previous page)
 * @pattern ^[0-9a-fA-F]{24}$
 */
cursor?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type GetActions200ItemsItemAutomationId = string | null;

export type GetActions200ItemsItemAutomationName = string | null;

export type GetActions200ItemsItemAutomationRunId = string | null;

export type GetActions200ItemsItemEmailGraphId = string | null;

export type GetActions200ItemsItemError = string | null;

export type GetActions200ItemsItemLinkedEmailAnyOfBodyPreview = string | null;

export type GetActions200ItemsItemLinkedEmailAnyOfFromEmail = string | null;

export type GetActions200ItemsItemLinkedEmailAnyOfFromName = string | null;

export type GetActions200ItemsItemLinkedEmailAnyOf = {
  bodyPreview: GetActions200ItemsItemLinkedEmailAnyOfBodyPreview;
  fromEmail: GetActions200ItemsItemLinkedEmailAnyOfFromEmail;
  fromName: GetActions200ItemsItemLinkedEmailAnyOfFromName;
  graphId: string;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  receivedAt: string;
  subject: string;
};

export type GetActions200ItemsItemLinkedEmail = GetActions200ItemsItemLinkedEmailAnyOf | null;

export type GetActions200ItemsItemSessionV2MessageId = string | null;

export type GetActions200ItemsItemSource = typeof GetActions200ItemsItemSource[keyof typeof GetActions200ItemsItemSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetActions200ItemsItemSource = {
  AUTOMATION: 'AUTOMATION',
  CHAT: 'CHAT',
} as const;

export type GetActions200ItemsItem = {
  automationDeleted: boolean;
  automationId?: GetActions200ItemsItemAutomationId;
  automationName?: GetActions200ItemsItemAutomationName;
  automationRunId?: GetActions200ItemsItemAutomationRunId;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  emailGraphId?: GetActions200ItemsItemEmailGraphId;
  error?: GetActions200ItemsItemError;
  id: string;
  input: unknown;
  linkedEmail: GetActions200ItemsItemLinkedEmail;
  output: unknown;
  sessionV2MessageId?: GetActions200ItemsItemSessionV2MessageId;
  source: GetActions200ItemsItemSource;
  success: boolean;
  toolName: string;
};

export type GetActions200NextCursor = string | null;

export type GetActions200 = {
  items: GetActions200ItemsItem[];
  nextCursor: GetActions200NextCursor;
};

